module.exports = __webpack_public_path__ + "img/home_title_m.bf9df5dd.png";